module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-danger\">\n        <em class=\"fa fa-warning\"></em><span style=\"margin-left: 10px;\" translate>Warning</span>\n    </div>\n    <div class=\"modal-body text-center\"><p translate>You can't add more than one section of this type.</p></div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\" translate>OK</button>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Creator/Workspace/ContentGuard/duplicated-section-info.html
// module id = 1111
// module chunks = 0